import script from "./InvoiceView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceView.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceView.vue?vue&type=style&index=0&id=2fb32671&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb32671"]])

export default __exports__